export default __webpack_public_path__ + "static/3-e38470ac172c0e96752cbf52b904be9b.jpg";